<template>
    <div class="xc-page xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <a>节目管理</a>
                <a href="">节目审核</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form class="xc-form">
                            <div class="xc-form-inline">
                                <xc-form-item label="节目名称:">
                                    <input type="text" placeholder="请输入节目名称" class="xc-input" name="programName" v-model="mix_query.programName">
                                </xc-form-item>
                                <xc-form-item label="节目来源:">
                                    <select name="programOrigin" class="xc-select" v-model="mix_query.programOrigin">
                                        <option value="">全部</option>
                                        <option :value="item.value" :key="index" v-for="(item,index) in globalConfig.programOrigin">
                                            {{item.desc}}
                                        </option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item label="投放门店:">
                                    <select name="putDistrict" class="xc-select" v-model="mix_query.deviceGroupId">
                                        <option value="">全部</option>
                                        <option :value="item.deviceGroupId" :key="index" v-for="(item,index) in globalConfig.deviceGroup">
                                            {{item.groupName}}
                                        </option>
                                    </select>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button class="xc-btn xc-btn-primary" type="submit" @click.prevent="mix_search">查询</button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>节目ID</th>
                                    <th>节目来源</th>
                                    <th>节目名称(时长)</th>
                                    <th>节目素材数</th>
                                    <th>状态</th>
                                    <th>投放时间</th>
                                    <th>备注</th>
                                    <th>投放设备</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr v-for="(item,index) in list" :key="index">
                                        <td>
                                            {{item.programId}}
                                        </td>
                                        <td>
                                            {{item.originName}}
                                        </td>
                                        <td>
                                            {{item.programName}}({{item.programDuration/1000}}s)
                                        </td>
                                        <td>
                                            {{item.sourceNum}}
                                        </td>
                                        <td>
                                            {{item.programStatus}}
                                        </td>
                                        <td>
                                            {{item.putinStartTime}} 至 {{item.putinEndTime}}
                                        </td>
                                        <td class="remark">
                                            {{item.rejectReson}}
                                        </td>
                                        <td class="xc-link">
                                            <div v-if="item.deviceNum">
                                                <a @click="action('watchPoint',item,$event)">查看</a>
                                            </div>
                                            <div v-else-if="item.programStatus == '待发布'">
                                                <a @click="action('selectPoint',item,$event)">去选点</a>
                                            </div>
                                        </td>
                                        <td>
                                            <template v-if="userModule.button['/ckips/program/auth']">
                                                <div class="xc-link">
                                                    <a @click="action('check',item,$event)">审核</a>
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="20" class="xc-s-tac">暂无数据</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize"/>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import myLayerImport from "@/libs/myLayer";
import programApi from '../api/program';
import globalConfigApi from '../api/global-config';
import { mapState, mapActions, watch } from 'vuex'
export default {
    name: 'programCheckList',
    mixins: [listMixin],
    data() {
        return {
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'programVersion',

            // 默认查询参数
            mix_query: {
                deviceGroupId: '',
                programStatus: '',
                programOrigin: '',
                programName: "",
            },

            // 列表数据
            list: [],

            // 模态框
            modalName: null,
            modal: {},

            // 全局配置
            globalConfig: {
                programStatus: [],
            },
        }
    },
    created() {
    },
    computed:{
        ...mapState([
            'userModule'
        ]),
    },
    methods: {
        // 初始化数据
        initData(ready) {

            if (ready) {

                globalConfigApi().then(v => {
                    this.globalConfig.programStatus = v.data.programStatus;
                    this.globalConfig.programOrigin = v.data.programOrigin;
                })

                programApi.getDeviceGroupSelect().then(v => {
                    this.globalConfig.deviceGroup = v.data;
                })
            }

            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
                programStatus:2,
            }

            programApi.programList(search).then(ret => {
                //添加mix_checkbox属性
                // this.list = this.mix_format(ret.data.list);
                this.list = ret.data.list;
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            })
        },

        // 操作单条数据
        action(...args) {
            const [action, item, index] = args;
            const e = args[args.length - 1];

            switch (action) {
                case 'check':
                    let backUrl = this.$route.fullPath;

                    //this.$router.push(this.$config.adminPath + '/program/' + item.programVersion + '/check?backUrl=' + backUrl);
                    // this.layer({
                    //     area: ["90%", "90vh"],
                    //     content: this.$config.adminPath + '/program/' + item.programVersion + '/check?backUrl=' + backUrl
                    // });
                    layer.openSubpage(this.$config.adminPath + '/program/' + item.programVersion + '/check?backUrl=' + backUrl);
                    break;
                case 'watchPoint':
                    this.layer({
                        area: ['977px', '609px'],
                        content: `${this.$config.adminPath}/program/${item.programVersion}/put-district-list`,
                    });
                    break;
                default:
                    break;
            }
        },
        layer(options) {
            layer.open({
                type: 2,
                title: false,
                closeBtn: 0,
                shadeClose: true,
                area: ['672px', '379px'],
                ...options
            });
        },
    },
    async mounted() {
        await myLayerImport();
    }
}
</script>

<style scoped lang="scss">
// .remark {
// }
</style>
